import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { setDriveData } from '../../../redux/Slices/InterviewSlice';
import {
  resetCompleteState,
  resetState,
  setAnswers,
  setIsStartTest,
  setSectionQuestions
} from '../../../redux/Slices/QuestionsSlice';
import {
  setCurrentSectionIndex,
  setCurrentQuestionIndex,
  setCurrentTime,
  setIsOnBreak,
  setRoundName,
  setCurrentSectionName,
  setSubTopicName,
  setResetSatrtFullTest,
  setCurrentCodeingQuestionAnswer,
  resetTestSettings
} from '../../../redux/Slices/StartTestSlice/startFulTest';
import { useAppDispatch, useAppSelector } from '../../../redux/store/hooks';
import {
  useEndStudentScheduleTestMutation,
  useSaveStudentScheduleTestMutation
} from '../../../services/scheduleTestApi';
import {
  useEndTestMutation,
  useSaveTestMutation,
  useGetCodeingEvaluationMutation,
  useRemoveUserTestMutation,
  useSoftSaveTestMutation,
  useSendTestActivityMutation,
  useProcessTestActivityMutation,
  useSaveMockTestMutation
} from '../../../services/startTestAPI/startTestApi';
import Button from '../../Common/Button';
import CommonDialog from '../../Common/Dialog';
import Loader from '../../Common/Loader';
import InstructionsPage from '../../Features/PracticeTest/Instructions/instructionsPage';
import QuestionContainer from '../../Features/PracticeTest/QuestionContainer';
import TestFooter from '../../Features/PracticeTest/TestFooter';
import TestHeader from '../../Features/PracticeTest/TestHeader';
import HRRound from '../../HrRound';
import SpeakingInterviewApp from '../../InterviewRound/InterviewRound';
import ModuleBreakTime from '../../ReUsableComponents/SectionBreakTimer';

type PracticeTestLayoutProps = {
  isScheduleTest?: boolean;
  isOnlyExit?: boolean;
  hideExitBtn?: boolean;
};
const PracticeTestLayout = ({
  isScheduleTest,
  isOnlyExit,
  hideExitBtn
}: PracticeTestLayoutProps) => {
  const { written } = useAppSelector(state => state.root.questions);
  const {
    isOnBreak,
    currentSectionIndex,
    currentQuestionIndex,
    allRoundsData,
    allSectionsData,
    showInstructions,
    currentSectionName,
    allCodeingQuestions,
    selectedCodeingLanguage,
    currentCodeingQuestionAnswer,
    userSelectedCompanyTest,
    isDriveTest,
    nextRound
  } = useAppSelector(state => state.root.startFulltest);

  const fulltest = useAppSelector(state => state.root.startFulltest);
  const questions = useAppSelector(state => state.root.questions);
  const { answers, userTestId } = useAppSelector(state => state.root.questions);
  const templete = useAppSelector(state => state.root.newTemplete);

  const totalTime = templete[0]?.rounds[0].totalRoundTime;
  const eachSection = templete[0]?.rounds[0].sections;
  const numberOfSections = eachSection?.length - 1;
  const round = useAppSelector(state => state.root.newTemplete[0]?.rounds[0]);
  const completeTest = useAppSelector(state => state.root.completeTestData);
  const path = window.location.pathname;
  const [startTime, setStartTime] = useState<Date | null>(null);
  const [isExitDialog, setIsExitDialog] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  const {
    instructions,
    sectionId,
    sectionSpanTime: currentSectionTime,
    generatedSectionQuestions: currentSectionQuestions
  } = useAppSelector(
    state => state.root.newTemplete[0]?.rounds[0]?.sections[currentSectionIndex]
  );
  const currentQuestion = written[currentQuestionIndex];

  const currentime = useAppSelector(
    state => state.root.startFulltest.currentTime
  );
  const [saveTest] = useSaveTestMutation();
  const [endTest] = useEndTestMutation();
  const [processTestActivity] = useProcessTestActivityMutation();
  const [removeTest] = useRemoveUserTestMutation();
  const [evaluateCode] = useGetCodeingEvaluationMutation();
  const [softSaveTest, { isLoading }] = useSoftSaveTestMutation();
  const dispatch = useAppDispatch();
  const [isloading, setIsLoading] = useState(false);
  const [sendTestActivity] = useSendTestActivityMutation();
  const [saveStudentScheduleTest] = useSaveStudentScheduleTestMutation();
  const [endScheduleTest] = useEndStudentScheduleTestMutation();
  const [saveMockTest] = useSaveMockTestMutation();

  useEffect(() => {
    setStartTime(new Date());
  }, [currentQuestionIndex]);

  const setCurrentRoundName = () => {
    allRoundsData.map(each => {
      if (each?.id === round?.roundId) {
        dispatch(setRoundName(each?.displayOnWebsite));
      }
    });
    allSectionsData.map(each => {
      if (each?.id === sectionId) {
        const currentSectionName = each?.displayOnWebsite;
        dispatch(setCurrentSectionName(currentSectionName));
      }
    });
  };

  const handleNext = () => {
    if (currentQuestionIndex < written.length - 1) {
      const endTime = new Date();
      setStartTime(endTime);
      const activityData = {
        userTestId,
        startTime,
        endTime,
        companyId: userSelectedCompanyTest?.companyId,
        sectionId: currentQuestion?.sectionId,
        topicId: currentQuestion?.topicId,
        roundId: currentQuestion?.roundId,
        userId: userSelectedCompanyTest?.userId,
        testSetId: userSelectedCompanyTest?.testSetId,
        fromQuestion: currentQuestionIndex + 1,
        toQuestion: currentQuestionIndex + 2,
        event: 'NEXT_QUESTION',
        questionId: currentQuestion?.id
      };
      sendTestActivity(activityData);
      dispatch(setCurrentCodeingQuestionAnswer(''));
      dispatch(setCurrentQuestionIndex(currentQuestionIndex + 1));
    }
  };

  const handleBack = () => {
    if (currentQuestionIndex > 0) {
      const endTime = new Date();
      setStartTime(endTime);
      const activityData = {
        userTestId,
        startTime,
        endTime,
        companyId: userSelectedCompanyTest?.companyId,
        sectionId: currentQuestion?.sectionId,
        topicId: currentQuestion?.topicId,
        roundId: currentQuestion?.roundId,
        userId: userSelectedCompanyTest?.userId,
        testSetId: userSelectedCompanyTest?.testSetId,
        fromQuestion: currentQuestionIndex + 1,
        toQuestion: currentQuestionIndex,
        event: 'NEXT_QUESTION',
        questionId: currentQuestion?.id
      };
      sendTestActivity(activityData);
      dispatch(setCurrentQuestionIndex(currentQuestionIndex - 1));
    }
  };

  const hadleQuestionJump = (number: number) => {
    const endTime = new Date();
    setStartTime(endTime);
    const activityData = {
      userTestId,
      startTime,
      endTime,
      companyId: userSelectedCompanyTest?.companyId,
      sectionId: currentQuestion?.sectionId,
      topicId: currentQuestion?.topicId,
      roundId: currentQuestion?.roundId,
      userId: userSelectedCompanyTest?.userId,
      testSetId: userSelectedCompanyTest?.testSetId,
      fromQuestion: currentQuestionIndex + 1,
      toQuestion: number + 1,
      event: 'JUMP',
      questionId: currentQuestion?.id
    };
    sendTestActivity(activityData);
    dispatch(setCurrentQuestionIndex(number));
  };

  const showInstructionsOrBreak = () => {
    if (isOnBreak) {
      return <ModuleBreakTime nextR='interview' />;
    } else {
      return <InstructionsPage />;
    }
  };
  const evaluateCodeingQuestions = async () => {
    try {
      let finalAnswers = JSON.parse(JSON.stringify(answers));

      for (const each of allCodeingQuestions) {
        try {
          const evaluatedCodeResponse = await evaluateCode(each);
          const newAnswer = {
            questionId: each?.questionId,
            userSelectedOption: '',
            isCorrectAnswer:
              evaluatedCodeResponse.data?.data?.isProvidedAnswerCorrect,
            actualCorrectOption: '',
            userSubmittedCode: each.userProvidedSoluation,
            languageUsed: each.language,
            aiGeneratedAnswer: evaluatedCodeResponse.data?.data?.idealAnswer,
            explanation: evaluatedCodeResponse.data?.data?.whatWentWrong,
            testCaseSummary: evaluatedCodeResponse.data?.data?.testCaseSummary,
            testCaseResults: evaluatedCodeResponse.data?.data?.testCaseResults,
            areasOfImprovement:
              evaluatedCodeResponse.data?.data?.areasOfImprovement,
            isPlagiarismCheckPassed:
              evaluatedCodeResponse.data?.data?.isPlagiarismCheckPassed
          };
          const updatedAnswers = JSON.parse(JSON.stringify(finalAnswers));

          if (updatedAnswers[each.sectionId]) {
            updatedAnswers[each.sectionId] = [
              ...updatedAnswers[each.sectionId],
              newAnswer
            ];
          } else {
            updatedAnswers[each.sectionId] = [newAnswer];
          }
          dispatch(setAnswers({ answers: updatedAnswers }));
          finalAnswers = updatedAnswers;
        } catch (error) {
          console.error('Error evaluating code:', error);
          toast.error('Error evaluating code submission');
        }
      }
      return finalAnswers;
    } catch (error) {
      console.error('Error in evaluateCodeingQuestions:', error);
      toast.error('Error processing coding questions');
      return answers;
    }
  };

  const getPayload = async () => {
    const finalAnswers = await evaluateCodeingQuestions();

    let totalQuestionsAttempted = 0;
    let totalQuestionsCorrect = 0;

    Object.values(finalAnswers)?.forEach(item => {
      (item as any[])?.forEach(ans => {
        if (ans?.userSelectedOption || ans?.userSubmittedCode) {
          totalQuestionsAttempted++;
          if (ans?.isCorrectAnswer) {
            totalQuestionsCorrect++;
          }
        }
      });
    });
    return {
      ...completeTest[0],
      answers: finalAnswers,
      totalQuestionsAttempted,
      totalQuestionsCorrect
    };
  };

  const handleSubmit = async () => {
    try {
      if (currentSectionIndex === numberOfSections && isDriveTest) {
        const endTime = new Date();
        setStartTime(endTime);
        const activityData = {
          userTestId,
          startTime,
          endTime,
          companyId: userSelectedCompanyTest?.companyId,
          sectionId: currentQuestion?.sectionId,
          topicId: currentQuestion?.topicId,
          roundId: currentQuestion?.roundId,
          userId: userSelectedCompanyTest?.userId,
          testSetId: userSelectedCompanyTest?.testSetId,
          fromQuestion: currentQuestionIndex + 1,
          toQuestion: currentQuestionIndex + 1,
          event: 'SUBMIT',
          questionId: currentQuestion?.id
        };
        sendTestActivity(activityData);
        dispatch(setIsOnBreak(true));
        const sectionBreakTime = 300;
        dispatch(setCurrentTime(sectionBreakTime));
        dispatch(setCurrentQuestionIndex(0));
        const payload = await getPayload();
        dispatch(setDriveData(payload));
      } else if (currentSectionIndex === numberOfSections && !isDriveTest) {
        const endTime = new Date();
        setStartTime(endTime);
        const activityData = {
          userTestId,
          startTime,
          endTime,
          companyId: userSelectedCompanyTest?.companyId,
          sectionId: currentQuestion?.sectionId,
          topicId: currentQuestion?.topicId,
          roundId: currentQuestion?.roundId,
          userId: userSelectedCompanyTest?.userId,
          testSetId: userSelectedCompanyTest?.testSetId,
          fromQuestion: currentQuestionIndex + 1,
          toQuestion: currentQuestionIndex + 1,
          event: 'SUBMIT',
          questionId: currentQuestion?.id
        };
        sendTestActivity(activityData);

        setIsLoading(true);
        const payload = await getPayload();
        if (params?.id) {
          const response = await saveMockTest({
            userId: params.id,
            userTestId: payload.id,
            payload
          }).unwrap();
          navigate(`/mock-results/true/${params.id}/${payload.id}`);
          return;
        }
        const saveResponse = isScheduleTest
          ? await saveStudentScheduleTest({
              scheduledUserTestId: userTestId,
              payload
            })
          : await saveTest({
              userTestId,
              payload
            });
        if (saveResponse.data.status === 'success') {
          isScheduleTest
            ? await endScheduleTest({ scheduledUserTestId: userTestId })
            : await endTest({ userTestId });
          await processTestActivity({ userTestId });
          toast.success('Test submitted successfully');
          setIsLoading(false);
          dispatch(setIsStartTest(false));
          dispatch(setCurrentSectionIndex(0));
          dispatch(resetCompleteState());
          dispatch(setResetSatrtFullTest());
          dispatch(setCurrentTime(0));
          dispatch(resetTestSettings());
        } else {
          setIsLoading(false);
          toast.error('Error saving test');
        }
      } else {
        dispatch(setIsOnBreak(true));
        const sectionBreakTime =
          templete[0]?.rounds[0]?.sections[currentSectionIndex]
            ?.sectionBreakTime;
        dispatch(setCurrentTime(sectionBreakTime));
        dispatch(setCurrentQuestionIndex(0));
        dispatch(resetState());
      }
    } catch (error) {
      console.error('Error in handleSubmit:', error);
      setIsLoading(false);
      toast.error('Error submitting test');
    }
  };
  const renderComponent = () => {
    if (isOnBreak || showInstructions) {
      return showInstructionsOrBreak();
    } else {
      return (
        <div
          className={`flex h-full w-full flex-col ${!currentQuestion?.isProgrammingQuestion && 'md:mx-auto md:max-w-4xl  2xl:w-1/2'}`}
        >
          <QuestionContainer
            questionNumber={currentQuestionIndex + 1}
            questionText={currentQuestion?.questionText ?? ' '}
            isProgrammingQuestion={currentQuestion?.isProgrammingQuestion}
            options={currentQuestion?.options ?? []}
            sectionId={currentQuestion?.sectionId}
            questionId={currentQuestion?.id}
            actualCorrectOption={currentQuestion?.correctAnswer}
            setStartTime={setStartTime}
            startTime={startTime || new Date()}
            currentQuestion={currentQuestion}
            handleSubmit={handleSubmit}
            handleNext={handleNext}
            isLastQuestion={currentQuestionIndex === written.length - 1}
          />
          <div className='mx-auto mt-4 flex w-full justify-between px-2 md:mx-auto md:w-[80%] md:px-0'>
            <div>
              {!currentQuestion?.isProgrammingQuestion && (
                <Button
                  label='Back'
                  handleClickBtn={handleBack}
                  disabled={currentQuestionIndex === 0}
                  variant='contained'
                  classes='text-sm md:text-base px-2 md:px-6 py-1 md:py-2'
                />
              )}
            </div>
            <div
              className={`rounded-full ${currentQuestion?.isProgrammingQuestion ? 'hidden' : 'block'}`}
            >
              {currentQuestionIndex === written.length - 1 ? (
                <Button
                  label='Submit'
                  handleClickBtn={handleSubmit}
                  variant='contained'
                  classes='text-sm md:text-base px-2 md:px-6 py-1 md:py-2'
                />
              ) : (
                <Button
                  label='Next'
                  handleClickBtn={handleNext}
                  disabled={currentQuestionIndex === written.length - 1}
                  variant='contained'
                  classes='text-sm md:text-base px-2 md:px-6 py-1 md:py-2'
                />
              )}
            </div>
          </div>
        </div>
      );
    }
  };

  const renderInterViewComponent = () => {
    return <SpeakingInterviewApp />;
  };

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      const message = 'Changes you made may not be saved.';
      e.returnValue = message;
      return message;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const handleBackButton = (event: any) => {
      const confirmBack = window.confirm(
        'Are you sure you want to leave this page? Any changes you have made will be lost, and youll need to start the test over from the beginning.'
      );
      if (!confirmBack) {
        event.preventDefault();
      } else {
        setIsLoading(false);
        dispatch(setIsStartTest(false));
        dispatch(setCurrentSectionIndex(0));
        dispatch(resetCompleteState());
        dispatch(setResetSatrtFullTest());
        dispatch(setCurrentTime(0));
      }
    };

    window.history.pushState(null, '', window.location.pathname);
    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [location, navigate]);

  useEffect(() => {
    const subTopicName =
      currentSectionQuestions[currentQuestionIndex]?.subTopic;
    dispatch(setSubTopicName(subTopicName));
  }, [currentQuestionIndex]);

  useEffect(() => {
    if (currentime <= 0 && !isOnBreak) {
      handleSubmit();
    }
  }, [currentime]);

  useEffect(() => {
    setCurrentRoundName();
    dispatch(setCurrentTime(currentSectionTime));
    dispatch(setSectionQuestions(currentSectionQuestions));
  }, [currentSectionIndex, currentSectionQuestions]);

  const triggerSoftSave = async () => {
    const templete2 = structuredClone(templete); // Better than JSON parse/stringify
    if (templete2[0]?.rounds[0]?.sections[currentSectionIndex]) {
      templete2[0].rounds[0].sections[currentSectionIndex].sectionSpanTime =
        currentime;
    }
    const payload = {
      questions,
      templete: templete2,
      fulltest,
      completeTest
    };

    const userTestId = completeTest[0]?.id;
    const testSetId = userSelectedCompanyTest?.testSetId;

    if (!userTestId || !testSetId || isDriveTest) {
      return;
    }

    await softSaveTest({ userTestId, testSetId, payload });
  };
  const saveInProgressRef = useRef(false);
  useEffect(() => {
    const apiCall = setTimeout(async () => {
      if (saveInProgressRef.current) return;

      try {
        saveInProgressRef.current = true;
        await triggerSoftSave();
      } catch (error) {
        console.error('Auto-save failed:', error);
      } finally {
        saveInProgressRef.current = false;
      }
    }, 3000);

    return () => clearTimeout(apiCall);
  }, [
    currentQuestionIndex,
    currentCodeingQuestionAnswer,
    answers,
    selectedCodeingLanguage
  ]);

  return (
    <>
      {isloading ? (
        <>
          <Loader
            mainMessage='Analyzing your responses with our AI... please wait.'
            subMessage='Don’t perform any other actions or reload the page.'
          />
        </>
      ) : (
        <div className='flex h-full flex-col overflow-scroll overscroll-contain rounded-xl bg-white'>
          {isDriveTest && nextRound === 'interview' ? (
            renderInterViewComponent()
          ) : isDriveTest && nextRound === 'hr' ? (
            <HRRound />
          ) : (
            <div className='h-full'>
              <div className='h-[10%]'>
                <TestHeader
                  title={
                    completeTest[0]?.testDTO?.testName ?? templete[0]?.examName
                  }
                  time='0:00'
                  currentSectionName={currentSectionName}
                  shouldShowTimer={isOnBreak || showInstructions}
                  closeFunction={() => setIsExitDialog(true)}
                  hideExitBtn={hideExitBtn}
                />
              </div>

              <div className='flex h-[80%] w-full justify-center overflow-auto'>
                {renderComponent()}
              </div>

              <div className='h-[10%] content-center'>
                <TestFooter
                  hadleQuestionJump={hadleQuestionJump}
                  questionNumber={currentQuestionIndex}
                  isProgrammingQuestion={currentQuestion?.isProgrammingQuestion}
                  examName={
                    completeTest[0]?.testDTO?.testName ?? templete[0]?.examName
                  }
                  shouldShowTimer={isOnBreak || showInstructions}
                />
              </div>
            </div>
          )}
          <CommonDialog
            close={() => setIsExitDialog(false)}
            isOpen={isExitDialog}
          >
            <div className='flex flex-col items-center justify-center p-4'>
              <h2 className='mb-4 text-lg font-semibold'>
                Are you sure you want to leave the test?
              </h2>
              {(isDriveTest || isOnlyExit) && (
                <p className='mb-4 text-sm '>
                  Your Progress will not be saved.
                </p>
              )}
              <Button
                label={
                  isDriveTest || isOnlyExit ? 'Exit Test' : 'Save and Exit'
                }
                disabled={isLoading}
                handleClickBtn={async () => {
                  try {
                    await triggerSoftSave();
                    dispatch(setResetSatrtFullTest());
                    dispatch(resetCompleteState());
                  } catch (error) {
                    console.error('Failed to save:', error);
                  }
                }}
                variant='contained'
              />
            </div>
          </CommonDialog>
        </div>
      )}
    </>
  );
};

export default PracticeTestLayout;
